import _ from "lodash";
import { Suspense, useEffect, useRef, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import { Toast } from "primereact/toast";
import LoadingOverlay from "react-loading-overlay-ts";
import DesignJobHeader from "./DesignJobHeader";
import DesignJobsList from "./DesignJobsList";
import ForceWarningPopUp from "./ForceWarningPopUp";
import PDFViewerPopUp from "./PDFViewerPopUp";
import RdtCicPopUp from "../Projects/ProjectPlan/RdtCicModal";
import VersionListPopUp from "./VerionListPopUp";
import UnAuthorizedComponent from "../UnAuthorized/UnAuthorizedComponent";
import { ProjectService } from "../../service/PegaService";
import {
  getDesignJobsData,
  getMarkUp,
  getVersionList,
  triggerForceApprove,
  zipDownload,
} from "../../apis/designJobApi";
import { AcpService } from "../../service/ACPService";
import { formCustomizeObject, isRoleMatch, multiFilterChange, showToast, toastMessages } from "../../utils";
import { AcpCommonService } from "../../service/AcpCommonService";
import { FilterMatchMode } from "primereact/api";
import { getColumnsOrder, setColumnsOrder } from "../../apis/commonApi";
import { colNameMapping } from "./utils";
import CustomizeView from "../common/CustomizeView";

import "./index.scss";

const headerName = "Design Jobs";

function DesignJob() {
  const [projectName, setProjectName] = useState();
  const [initialDesignJobsData, setInitialDesignJobsData] = useState();
  const [designJobsData, setDesignJobsData] = useState();
  const [projectState, setProjectState] = useState();
  const [filterDesignJobsData, setFilterDesignJobsData] = useState([]);
  const [selectedJobsData, setSelectedJobsData] = useState([]);
  const [projectColumnName, setProjectColumnNames] = useState([]);
  const [selectedColumnName, setSelectedColumnName] = useState(null);
  const [resetKey, setResetKey] = useState(0);
  const [isSearch, isSearchSet] = useState(false);
  const [searchHeader, setSearchHeader] = useState({});
  const [loader, setLoader] = useState(true);
  const [showWarning, setShowWarning] = useState(false);
  const [showMarkUpPopUp, setShowMarkupPopUp] = useState(false);
  const [showVersionPopUp, setShowVersionPopUp] = useState(false);
  const [selectedMarkUp, setSelectedMarkUp] = useState("");
  const [selectedJobVersionDetails, setSelectedJobVersionDetails] = useState({
    jobName: "",
    jobId: "",
    folderName: "",
  });
  const [markUpList, setMarkupList] = useState([]);
  const [versionList, setVersionList] = useState([]);
  const [projectDetails, setProjectDetails] = useState([]);
  const [designJobId, setDesignJobId] = useState("");
  const [availableFields, setAvailableFields] = useState([]);
  const [selectedFields, setSelectedFields] = useState({});
  const [frozenColumns, setFrozenColumn] = useState([]);
  const [allColumnNames, setAllColumnNames] = useState([]);
  const [pgDefaultColumns, setPGDefaultColumns] = useState({});
  const [customizeViewFields, setCustomizeViewFields] = useState([]);
  const [sortData, setSortData] = useState(null);
  const [visible, setVisible] = useState(false);
  const [conditionMatched, setConditionMatched] = useState(false);
  const [showPDFViewer, setShowPDFViewer] = useState(false);
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [selectAllCheckedDisabled, setSelectAllCheckedDisabled] = useState(false);
  const [pdfViewerInfo, setPDFViewerInfo] = useState({
    headerName: "",
    proofscopeURL: "",
  });
  const [designJobWrapFreeText, setDesignJobWrapFreeText] = useState(() => {
    const saved = sessionStorage.getItem("designJobWrapFreeText");
    return saved === "true";
  });
  const [userAccess, setUserAccess] = useState(false);
  const [accessType, setAccessType] = useState(null);

  const { DropDownValuesData } = useSelector((state) => state?.DropDownValuesReducer);
  const columnList = DropDownValuesData?.ArtworkAgilityDesignJobs;
  const StorageData = localStorage.getItem("customizeViewFieldsDesignJobs");
  const customizeViewFieldsStorage = StorageData && JSON.parse(StorageData);

  const {
    userDetails: { UserGroup, AccessGroup },
  } = useSelector((state) => state?.UserDetailsReducer);
  const User = useSelector((state) => state?.UserReducer);
  const userInformation = User.userInformation;

  const location = useLocation();
  const { ProjectID } = useParams();
  const currentUrl = location?.pathname;
  const currentUrlBasePage = currentUrl?.split("/")[1];

  const filterArray = useRef([]);
  const selectedFieldsRef = useRef([]);
  const selectedColumnList = useRef([]);
  const colAllSelected = useRef([]);
  const toast = useRef(null);

  useEffect(() => {
    let columnWidthDesignJobsScreen = {};

    let getJsonStoredWidthColumns = localStorage.getItem("columnWidthDesignJobsScreen");
    let getStoredWidthColumns = JSON.parse(getJsonStoredWidthColumns);
    const checkEmptyObject = _.isEmpty(getStoredWidthColumns);

    if (checkEmptyObject) {
      localStorage.setItem(
        "columnWidthDesignJobsScreen",
        JSON.stringify(columnWidthDesignJobsScreen),
      );
    }

    let availableFields;
    const selectedFeilds = ProjectService.getDesignJobColumns();
    availableFields = allColumnNames?.filter(function (objFromA) {
      return !selectedFeilds.find(function (objFromB) {
        return objFromA === objFromB;
      });
    });

    const customizeViewFieldsUpdated = formCustomizeObject(availableFields, [], selectedFeilds);
    setPGDefaultColumns(customizeViewFieldsUpdated);
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const ProjectData = _.cloneDeep(designJobsData);

        if (ProjectData && ProjectData.length) {
          setAllColumnNames(reorderColumns());
        }

        // according to pathname we need to call api and store column name in local storage
        let columnNamesJson = localStorage.getItem("allDesignJobColumnNames");
        let columnNames = JSON.parse(columnNamesJson);
        if (columnNames && columnNames?.length) {
          columnNames = AcpService?.removeCommonValues(columnNames, frozenColumns);
          columnNames = [...frozenColumns, ...columnNames];
          setProjectColumnNames(columnNames);
        } else {
          let columnNames = ProjectService.getDesignJobColumns();
          columnNames = AcpService?.removeCommonValues(columnNames, frozenColumns);
          columnNames = [...frozenColumns, ...columnNames];
          setProjectColumnNames(columnNames);
          localStorage.setItem("allDesignJobColumnNames", JSON.stringify(columnNames));
        }
      } catch (err) {
        console.log("error", err);
      }
    })();
  }, [designJobsData]);

  useEffect(() => {
    if (userInformation?.userid != undefined) setToInitialCustomizeView();

    getCustomizedView();
  }, [allColumnNames, userInformation]);

  useEffect(() => {
    if (showVersionPopUp) {
      setLoader(true);
      fetchVersionList();
    }
  }, [showVersionPopUp]);

  useEffect(() => {
    if (showMarkUpPopUp) {
      setLoader(true);
      fetchMarkUpList();
    }
  }, [showMarkUpPopUp]);

  useEffect(() => {
    if (accessType === "Hidden") {
      setUserAccess(false);
    } else if (accessType === "Read") {
      setUserAccess(true);
    } else if (accessType === "Write") {
      setUserAccess(true);
    }
  }, [accessType]);

  useEffect(() => {
    const isUserAccess = isRoleMatch(AccessGroup, ["ProjectManager", "TaskOwner"]);

    if (isUserAccess) {
      fetchData();
    } else {
      setLoader(false);
    }
  }, [ProjectID, AccessGroup]);

  useEffect(() => {
    let temp = projectColumnName?.reduce((acc, curr) => {
      let matchMode =
        selectedFields[curr] && selectedFields[curr]?.length > 0
          ? FilterMatchMode.IN
          : FilterMatchMode.CONTAINS;
      return {
        ...acc,
        [curr]: {
          value:
            selectedFields[curr] && selectedFields[curr]?.length > 0 ? selectedFields[curr] : null,
          matchMode: matchMode,
        },
      };
    }, {});

    setSearchHeader(temp);
  }, [selectedFields, projectColumnName]);

  // it will invoke to check/uncheck the select all table header checkbox
  useEffect(() => {
    const filter_Jobs_With_FileVersion = designJobsData?.filter(data => data?.FileVersion !== "")
    const isAllSelected = filter_Jobs_With_FileVersion?.map(data => data.selected)?.every(val => val);

    setSelectAllChecked(isAllSelected)
  }, [selectedJobsData])

  const reorderColumns = () => {
    const requiredColumnOrderArray = columnList
      ?.sort((a, b) => a?.Sequence - b?.Sequence)
      ?.map((col) => col?.Field_Name);

    return requiredColumnOrderArray;
  };

  const fetchData = async () => {
    const payLoad = {
      ArtworkAgilityPage: {
        UserId: userInformation?.userid,
        UserGroup: UserGroup,
      },
    };

    const designJobsResponse = await getDesignJobsData(ProjectID, payLoad);

    const shawdowValue = designJobsResponse?.data?.DesignJobsList?.map((jobObj) => ({
      ...jobObj,
      BufferToWork: jobObj?.BufferToWork === "9999.00" ? "N/A" : jobObj?.BufferToWork,
      selected: false
    }));

    setAccessType(designJobsResponse?.data?.AccessType);
    setInitialDesignJobsData(shawdowValue);
    setDesignJobsData(shawdowValue);
    setSelectAllCheckedDisabled(!shawdowValue?.some(data => data?.FileVersion !== ""));
    setProjectDetails({
      BU: designJobsResponse?.data?.BU,
      Region: designJobsResponse?.data?.Region,
      ProjectID,
    });
    setProjectState(designJobsResponse?.data?.ProjectState);
    setProjectName(designJobsResponse?.data?.ProjectName);
    setLoader(false);
  };

  const fetchMarkUpList = async () => {
    const markUpListResponse = await getMarkUp(ProjectID, selectedMarkUp);

    if (markUpListResponse?.status === 200) {
      let rejectionListLength = markUpListResponse?.data?.RejectionReasons?.length;
      const modifyRejectionList = markUpListResponse?.data?.RejectionReasons?.map((rejection) => ({
        ...rejection,
        count: rejectionListLength--,
      }));

      setMarkupList(modifyRejectionList);
    } else {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Failed to fetch markups",
        life: 3000,
      });
    }
    setLoader(false);
  };

  const fetchVersionList = async () => {
    const versionListResponse = await getVersionList(ProjectID, selectedJobVersionDetails?.jobId);

    if (versionListResponse?.status === 200) {
      setVersionList(versionListResponse?.data?.FileList);
    } else {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Failed to fetch version list",
        life: 3000,
      });
    }
    setLoader(false);
  };

  const getCustomizedView = (isFrozen) => {
    const selectedData = customizeViewFieldsStorage?.selectedFields?.fieldsData || [];
    const freezedData = customizeViewFieldsStorage?.freezedColumns?.fieldsData || [];
    const availableData = customizeViewFieldsStorage?.availableFields?.fieldsData || [];
    let availableFields;

    if (availableData?.length > 0) {
      availableFields = availableData;
    } else {
      let updatedColumnFinal = allColumnNames?.filter(function (objFromA) {
        return !projectColumnName.find(function (objFromB) {
          return objFromA === objFromB;
        });
      });
      const intermediateColumn = AcpService?.removeCommonValues(
        updatedColumnFinal,
        freezedData?.length ? freezedData : frozenColumns,
      );
      const availableColumnToSelect = AcpService?.removeCommonValues(
        intermediateColumn,
        selectedData?.length ? selectedData : projectColumnName,
      );
      availableFields = availableColumnToSelect?.length
        ? availableColumnToSelect
        : updatedColumnFinal;
    }

    const freezedColumns = isFrozen
      ? frozenColumns
      : freezedData?.length
        ? freezedData
        : frozenColumns;

    let selectedFields = selectedData?.length ? selectedData : projectColumnName;
    selectedFields = AcpService?.removeCommonValues(selectedFields, freezedColumns);

    const customizeViewFieldsUpdated = formCustomizeObject(
      availableFields,
      freezedColumns,
      selectedFields,
    );

    const column = AcpService?.removeCommonValues(
      selectedFields,
      freezedData?.length ? freezedData : frozenColumns,
    );
    const projectColumnNamesUpdated =
      freezedColumns.length > 0 ? [...freezedColumns, ...column] : selectedFields;
    setProjectColumnNames(projectColumnNamesUpdated);
    if (!isFrozen) {
      setFrozenColumn(freezedColumns);
      setCustomizeViewFields(customizeViewFieldsUpdated);
    }
    return customizeViewFieldsUpdated;
  };

  const handleCustomizedView = async (data) => {
    if (data !== undefined && data?.length !== 0) {
      const parsedData =
        data?.selectedFields?.fieldsData?.length > 0
          ? data?.selectedFields?.fieldsData
          : data && JSON.parse(data);
      const freezedData = parsedData?.freezedColumns?.fieldsData || [];
      let selectedData = parsedData?.selectedFields?.fieldsData || [];
      localStorage.setItem("customizeViewFieldsDesignJobs", JSON.stringify(parsedData));
      selectedData = AcpService?.removeCommonValues(selectedData, freezedData);
      await setColumnsOrder(
        userInformation?.userid,
        "customizeViewFieldsDesignJobs",
        "NA",
        "NA",
        false,
        JSON.stringify(parsedData),
      );
      selectedData = [...freezedData, ...selectedData];
      setProjectColumnNames(selectedData);
      setCustomizeViewFields(parsedData);
      getAvaiableFeilds(parsedData);
      freezedData?.length > 0 && setFrozenColumn([...freezedData]);
      freezedData?.length == 0 && setFrozenColumn([]); //when you drag from frozen to selected reset the state
    }
  };

  const getAvaiableFeilds = (customizeViewFields) => {
    const availableData = customizeViewFields?.availableFields?.fieldsData;
    let availableDataList = [];
    if (availableData?.length > 0) {
      availableData.map((item) => {
        const innerObj = {
          Field_Name: item,
        };
        availableDataList.push(innerObj);
      });
      setAvailableFields(availableDataList);
    }
  };

  const setToInitialCustomizeView = async () => {
    let availableFields;
    const selectedFeildsVal = ProjectService.getDesignJobColumns();
    availableFields = allColumnNames?.filter(function (objFromA) {
      return !selectedFeildsVal?.find(function (objFromB) {
        return objFromA === objFromB;
      });
    });

    let customizeViewColumnFromPega = await getColumnsOrder(
      userInformation?.userid,
      "customizeViewFieldsDesignJobs",
      "NA",
      "NA",
    );
    if (customizeViewColumnFromPega != null && customizeViewColumnFromPega != "") {
      setCustomizeViewFields(customizeViewColumnFromPega);
      getAvaiableFeilds(customizeViewColumnFromPega);
      localStorage.setItem(
        "customizeViewFieldsDesignJobs",
        JSON.stringify(customizeViewColumnFromPega),
      );
    } else {
      const customizeViewFieldsUpdated = formCustomizeObject(
        availableFields,
        [],
        selectedFeildsVal,
      );
      setCustomizeViewFields(customizeViewFieldsUpdated);
      localStorage.setItem(
        "customizeViewFieldsDesignJobs",
        JSON.stringify(customizeViewFieldsUpdated),
      );
      await setColumnsOrder(
        userInformation?.userid,
        "customizeViewFieldsDesignJobs",
        "NA",
        "NA",
        false,
        JSON.stringify(customizeViewFieldsUpdated),
      );
    }
  };

  const clearFiltersResetToPG = async (param) => {
    setLoader(true);
    localStorage.setItem("customizeViewFieldsDesignJobs", JSON.stringify({}));
    await setColumnsOrder(
      userInformation?.userid,
      "customizeViewFieldsDesignJobs",
      "NA",
      "NA",
      true,
      "",
    );
    await setColumnsOrder(
      userInformation?.userid,
      "DesignJobsAllColumnNames",
      "NA",
      "NA",
      true,
      "",
    );
    setProjectColumnNames(ProjectService.getDesignJobColumns());
    await setToInitialCustomizeView();
    setFrozenColumn([]);
    setResetKey((prev) => prev + 1);
    setLoader(false);
  };

  const getUpdatedAllColumnFormat = (columns) => {
    return columns?.map((el) => {
      return {
        width: 250,
        Sequence: "",
        freeze: false,
        Field_Name: el,
        reorder: false,
        Column_Name: colNameMapping[el],
        sortAtoZ: false,
        sortZtoA: false,
        Attribute_Type: "Free Text",
      };
    });
  };

  const onGlobalFilterChange = (e, colName) => {
    const { value, multiplesFlag, arr } = multiFilterChange(
      e,
      colName,
      selectedColumnName,
      selectedFields,
      setSelectedFields,
      designJobsData,
      filterArray,
      selectedColumnList,
      colAllSelected,
      selectedFieldsRef,
    );
    const _selectedFieldsRef =
      selectedFieldsRef?.current.length > 0 &&
      selectedFieldsRef?.current.map((el, i) => {
        if (Object.keys(arr)?.[0] === Object.keys(el)?.[0]) {
          return {
            ...el,
            [`${selectedColumnName}`]: arr[selectedColumnName],
          };
        } else {
          return el;
        }
      });
    if (AcpService.areAllPropertiesEmptyArrays(_selectedFieldsRef)) {
      localStorage.removeItem("_selectedFieldsRefCurrentDesignJobs");
    }
    if (filterArray.current?.length) {
      const selectedColRes = _.uniqBy(colAllSelected?.current);
      if ((value?.length > 0 && !multiplesFlag) || selectedColRes?.length >= 1) {
        const _selectedFieldsRefWithoutEmptyArray =
          AcpService.removeEmptyArrays(_selectedFieldsRef);
        const filterData = AcpService.filterDataByfilters(
          designJobsData,
          _selectedFieldsRefWithoutEmptyArray,
          setConditionMatched,
          "DesignJobs",
        );
        const convertedObj = AcpCommonService.convertArrayToObject(
          _selectedFieldsRefWithoutEmptyArray,
        );
        const uniqueObj = AcpCommonService.getUniqueValuesObject(convertedObj);
        setSelectedFields(uniqueObj);
        if (filterData?.length && sortData?.length) {
          onSort(sortData[0], sortData[1], filterData);
        } else {
          setFilterDesignJobsData(filterData);
          selectedColumnList.current = filterData;
        }
      } else {
        selectedColumnList.current = [];
        selectedFieldsRef.current = [];
        setSelectedFields({});
        setFilterDesignJobsData([]);
      }
    } else {
      selectedColumnList.current = [];
      selectedFieldsRef.current = [];
      setSelectedFields({});
      setFilterDesignJobsData([]);
    }
  };

  const onSort = (column, direction, filterData) => {
    const sortedData = filterData?.length
      ? filterData
      : filterDesignJobsData?.length
        ? filterDesignJobsData
        : designJobsData;
    const sortedDataSet = AcpService.sortDataFirstStringThenNumeric(sortedData, column, direction);

    setSortData([column, direction]);
    if (filterData?.length || filterDesignJobsData?.length) {
      setFilterDesignJobsData(sortedDataSet);
      selectedColumnList.current = sortedDataSet;
    } else {
      setDesignJobsData(sortedDataSet);
    }
  };

  const onHide = () => {
    setShowPDFViewer(false);
    setPDFViewerInfo({
      headerName: "",
      proofscopeURL: "",
    });
  };

  const checkIsFilterApplied = () => {
    let isSelectedVal = false;
    if (selectedFields && Object.keys(selectedFields)?.length > 0) {
      isSelectedVal = Object.values(selectedFields)?.some((value) => value.length > 0);
    }
    return isSelectedVal;
  };
  const isFilterEnabled = isSearch || checkIsFilterApplied();

  const onNo = () => {
    setShowWarning(false);
    setDesignJobId("");
  };

  const onYes = async () => {
    const forceApproveResponse = await triggerForceApprove(ProjectID, designJobId);

    if (forceApproveResponse.status === 200) {
      toast.current.show({
        severity: "success",
        summary: "Success",
        detail: "Force Approve triggered successfully",
        life: 3000,
      });
      setShowWarning(false);
      setDesignJobId("");
      setLoader(true);
      fetchData();
    } else {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Failed to trigger",
        life: 3000,
      });
    }
  };

  const handleChildClick = (isClicked) => {
    if (!isClicked) {
      clearFilter();
    }
  };

  const onSearchClick = () => isSearchSet(!isSearch);

  const clearFilter = () => {
    setDesignJobsData(initialDesignJobsData);
    setSelectedFields({});
    isSearchSet(false);
    setFilterDesignJobsData([]);

    selectedFieldsRef.current = [];

    if (sortData?.length) {
      onSort(sortData[0], sortData[1], initialDesignJobsData);
    }
  };

  const closeMarkUpPopUp = () => {
    setShowMarkupPopUp(false)
    setMarkupList([])
    setSelectedMarkUp("")
  }

  const closeVersionPopUp = () => {
    setShowVersionPopUp(false);
    setVersionList([]);
    setSelectedJobVersionDetails({
      jobName: "",
      jobId: "",
      folderName: "",
    });
  };

  const clearAll = () => {
    const designJobsDataMod = _.cloneDeep(designJobsData).map((data) => ({
      ...data,
      selected: false,
    }));

    const filterDesignJobsDataMod = _.cloneDeep(filterDesignJobsData).map((data) => ({
      ...data,
      selected: false,
    }));

    setDesignJobsData(designJobsDataMod);
    setFilterDesignJobsData(filterDesignJobsDataMod);
    setSelectedJobsData([]);
    setSelectAllChecked(false)
  };

  const onDownloadClick = async () => {
    try {
      await zipDownload(selectedJobsData);

      // Show warning toast once download begins
      showToast(toast, "warn", toastMessages.downloading.detail, {
        life: 3000,
        clearPrevious: true,
      });
    } catch (error) {
      // Show error toast if the download fails
      showToast(toast, "error", toastMessages.downloadFailed.detail, {
        life: 3000,
        clearPrevious: true,
      });
    }
  };

  return (
    <>
      <Toast ref={toast} position="top-right" />
      {loader ? (
        <LoadingOverlay active={true} spinner text="" className="overlay-loader" />
      ) : userAccess ? (
        <Suspense fallback={<LoadingOverlay active={true} spinner text="" />}>
          <div className="design-jobs projectTable myProjectAnddAllProjectList">
            <DesignJobHeader
              projectName={projectName}
              headerName={headerName}
              hyperLink={`/${currentUrlBasePage}/projectPlan/${ProjectID}`}
              designJobsData={designJobsData}
              filterDesignJobsData={filterDesignJobsData}
              designJobWrapFreeText={designJobWrapFreeText}
              setDesignJobWrapFreeText={setDesignJobWrapFreeText}
              columnNames={projectColumnName}
              isFilterEnabled={isFilterEnabled}
              onChildClick={handleChildClick}
              onSearchClick={onSearchClick}
              filename="DesignJobs_Records"
              projectState={projectState}
              setVisible={setVisible}
              selectedJobsData={selectedJobsData}
              onDownloadClick={onDownloadClick}
            />
            <CustomizeView
              availableFields={availableFields || []}
              showTaskDialog={visible}
              headerName={headerName}
              onClose={() => setVisible(false)}
              customizeViewFields={customizeViewFields}
              setCustomizeViewFields={handleCustomizedView}
              resetToPgDefault={clearFiltersResetToPG}
              allColumns={getUpdatedAllColumnFormat(allColumnNames)}
              setResetKey={setResetKey}
              pgDefaultColumns={pgDefaultColumns}
            />
            <DesignJobsList
              projectColumnName={projectColumnName}
              selectedColumnList={selectedColumnList}
              selectedFieldsRef={selectedFieldsRef}
              initialDesignJobsData={initialDesignJobsData}
              designJobsData={designJobsData}
              setDesignJobsData={setDesignJobsData}
              selectedJobsData={selectedJobsData}
              setSelectedJobsData={setSelectedJobsData}
              selectAllChecked={selectAllChecked}
              setSelectAllChecked={setSelectAllChecked}
              selectAllCheckedDisabled={selectAllCheckedDisabled}
              setConditionMatched={setConditionMatched}
              filterDesignJobsData={filterDesignJobsData}
              onGlobalFilterChange={onGlobalFilterChange}
              setFilterDesignJobsData={setFilterDesignJobsData}
              resetKey={resetKey}
              setResetKey={setResetKey}
              isSearch={isSearch}
              tableLoader={loader}
              setShowWarning={setShowWarning}
              onSort={onSort}
              selectedColumnName={selectedColumnName}
              setSelectedColumnName={setSelectedColumnName}
              sortData={sortData}
              setSortData={setSortData}
              selectedFields={selectedFields}
              frozenColumns={frozenColumns}
              setSelectedFields={setSelectedFields}
              setShowPDFViewer={setShowPDFViewer}
              setPDFViewerInfo={setPDFViewerInfo}
              searchHeader={searchHeader}
              designJobWrapFreeText={designJobWrapFreeText}
              setDesignJobId={setDesignJobId}
              setSelectedMarkUp={setSelectedMarkUp}
              setVersionList={setVersionList}
              setShowMarkupPopUp={setShowMarkupPopUp}
              setShowVersionPopUp={setShowVersionPopUp}
              setSelectedJobVersionDetails={setSelectedJobVersionDetails}
              projectDetails={projectDetails}
              clearAll={clearAll}
            />
          </div>
          <ForceWarningPopUp visible={showWarning} onNo={onNo} onYes={onYes} />
          <PDFViewerPopUp
            pdfViewerInfo={pdfViewerInfo}
            showPDFViewer={showPDFViewer}
            onHide={onHide}
          />
          <RdtCicPopUp
            visible={showMarkUpPopUp}
            onCancel={closeMarkUpPopUp}
            rejectionReasonsList={markUpList}
            loader={false}
            jobType={selectedMarkUp.startsWith("DT_DJob") ? "RDT" : "CIC"}
          />
          <VersionListPopUp
            visible={showVersionPopUp}
            onCancel={closeVersionPopUp}
            selectedJobVersionDetails={selectedJobVersionDetails}
            tableData={versionList}
            projectDetails={projectDetails}
            setPDFViewerInfo={setPDFViewerInfo}
            setShowPDFViewer={setShowPDFViewer}
          />
        </Suspense>
      ) : (
        AccessGroup && AccessGroup.length && <UnAuthorizedComponent nowrapper={true} />
      )}
    </>
  );
}

export default DesignJob;
